import { useContext } from 'react';
import { RouterContext } from '@okapi/router-react/dist/Provider';

/**
 *
 * @description Униварсальная замена хуков "@okapi/router-react"
 * @example
 *  import { useRouter } from 'common/hooks';
 *  const router = useRouter();
 *  const location = router.getPath();
 *  const searchString = router.getSearch();
 *  const queryParams = router.getSearchParsed()
 */
export const useRouter = () => {
  return useContext(RouterContext);
};
